import { Grid, Image } from "capitalrx-components-2.0";

import ErrorMessageBody from "./ErrorMessageBody";
import ErrorRover from "./images/error-rover.svg?url";

import styles from "./Error.module.scss";

interface Props {
  type?: "reject";
}

const ErrorSection = (props: Props): JSX.Element => {
  const { type } = props;

  return (
    <div className={styles.ErrorContainer}>
      <Grid container justifyContent="center" alignItems="center" className={styles.Error}>
        <Grid item colLg={7} colMd={5} colSm={6}>
          <ErrorMessageBody type={type} />
        </Grid>
        <Grid item colLg={3} colMd={5} colSm={6} className={styles.ErrorImage}>
          <Image src={ErrorRover} alt="Error Image" />
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorSection;
